export const SERVICES = [
    {
        id: "face-analysis",
        category: "appearance",
        name: "얼굴 분석 (Face Analysis)",
        description: "사진 한 장으로 얼굴형, 남성성/여성성 지표, 매력도를 과학적으로 분석합니다. TETO/EGEN 지표를 확인해보세요.",
        badge: "Image Upload",
        route: "/info",
        steps: ["사진 업로드", "AI 분석 진행", "결과 확인"],
        icon: "📸"
    },
    {
        id: "aesthetic-test",
        category: "appearance",
        name: "추구미 분석 (Chugumi)",
        description: "나는 어떤 분위기를 추구할까? 간단한 테스트로 나의 숨겨진 취향과 어울리는 스타일을 찾아보세요.",
        badge: "Style Analysis",
        route: "/chugumi-test",
        steps: ["취향 질문", "추구미 분석", "스타일 추천"],
        icon: "✨"
    },
    {
        id: "chemistry-test",
        category: "appearance",
        name: "궁합분석 (Chemistry)",
        description: "두 사람의 얼굴 데이터를 비교해 첫인상 끌림과 시각적 케미를 분석합니다.",
        badge: "Face Chemistry",
        route: "/chemistry-test",
        steps: ["두 사람 사진 업로드", "궁합 매트릭스 분석", "케미 리포트 확인"],
        icon: "💞"
    },
    {
        id: "style-check",
        category: "appearance",
        name: "스타일 체크 (Style Check)",
        description: "착장과 얼굴 인상, 추구미의 조화를 AI로 분석하고 나에게 어울리는 스타일을 추천받아보세요.",
        badge: "AI Outfit Review",
        route: "/style-check",
        steps: ["착장·얼굴 사진 업로드", "AI 스타일 분석", "맞춤 추천 확인"],
        icon: "🪞"
    },
    {
        id: "mega-test",
        category: "inner",
        name: "메가 시너지 테스트 (Dual)",
        description: "",
        badge: "Dual Analysis",
        route: "/mega-test",
        steps: [],
        icon: "⚡"
    },
    {
        id: "beyond-test",
        category: "inner",
        name: "비욘드 테스트 (Beyond)",
        description: "",
        badge: "Ideal World",
        route: "/beyond-test",
        steps: [],
        icon: "🪐"
    }
];
